module.exports = __webpack_public_path__ + "z.no2.e2232968.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/z.no2.jpg
// module id = dg4x
// module chunks = 0